// src/contexts/LoginModalContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

const LoginModalContext = createContext();

export const useLoginModal = () => {
    const context = useContext(LoginModalContext);
    if (!context) {
        throw new Error('useLoginModal must be used within LoginModalProvider');
    }
    return context;
};

export const LoginModalProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [initialView, setInitialView] = useState('login');

    const openLoginModal = useCallback((view = 'login') => {
        console.log('🔓 Apertura modal login:', view);
        setInitialView(view);
        setIsOpen(true);
    }, []);

    const closeLoginModal = useCallback(() => {
        console.log('🔒 Chiusura modal login');
        setIsOpen(false);
    }, []);

    const switchToLogin = useCallback(() => {
        setInitialView('login');
    }, []);

    const switchToRegister = useCallback(() => {
        setInitialView('regiterStep1');
    }, []);

    return (
        <LoginModalContext.Provider value={{
            isOpen,
            initialView,
            openLoginModal,
            closeLoginModal,
            switchToLogin,
            switchToRegister
        }}>
            {children}
        </LoginModalContext.Provider>
    );
};
